/**
* Component: assetCreateUpdateRepository.js
* Description: This repository manages the asset creation and updation.
*/

import axios from "axios";
import { getAuthToken, getCreatedBy, getFacilityId, getModifiedBy } from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";

//common payload parameters for FEMS and BEMS 
const commonFillRequestBody = (selectedGridData) => {
 
    const facilityId = getFacilityId("facilityid");
    const getmodifiedBy = getModifiedBy();
    return {
        id: selectedGridData?.assetId || selectedGridData?.id || "",
        facilityid: facilityId,
        //basicDetails fields
        Assetno: selectedGridData?.assetNo || selectedGridData?.assetno,
        assetdesc: selectedGridData?.assetdesc || "",
        isauthorized: selectedGridData?.isauthorized || false,
        userlocationid: selectedGridData?.userlocationid || "",
        typecodeid: selectedGridData?.typecodeid || "",
        isloanerasset: selectedGridData?.isloanerasset || false,
        isppmrequiredflag: selectedGridData?.isppmrequiredflag || false,
        reason: selectedGridData?.reason || "",
        testcommissionoldno: selectedGridData?.testcommissionoldno || "",
        parentassetid: selectedGridData?.parentassetid || "",
        Oldassetno: selectedGridData?.oldassetno || "",
        Finanaceassetno: selectedGridData?.finanaceassetno || "",
        //assetSpecification fields
        make: selectedGridData?.make || "",
        brand: selectedGridData?.brand || "",
        model: selectedGridData?.model || "",
        serialno: selectedGridData?.serialno || "",
        version:selectedGridData?.version || "",
        manufacturer: selectedGridData?.manufacturer || "",
        lifespan: selectedGridData?.lifespan === 0 ? 0 : (selectedGridData?.lifespan || ""),
        builtuparea: selectedGridData?.builtuparea || "",
        footprint: selectedGridData?.footprint || "",
        landarea: selectedGridData?.landarea || "",
        capacity: selectedGridData?.capacity || "",
        //purchaseDetails fields
      //  depreciationvalue: selectedGridData?.depreciationvalue || "",
        purchasecost: selectedGridData?.purchasecost === 0 ? 0 : (selectedGridData?.purchasecost || ""),
        isunderwarranty: selectedGridData?.isunderwarranty || false,
        warrantystartdate: selectedGridData?.warrantystartdate || "",
        warrantyenddate: selectedGridData?.warrantyenddate || "",
        commissioningdate: selectedGridData?.commissioningdate || "",
        assettransferlocationid: selectedGridData?.assettransferlocationid || "",
        vendorid: selectedGridData?.vendorid || "",
        purchaseorderno: selectedGridData?.purchaseorderno || "",
        accessories: selectedGridData?.accessories || "",
        cumpartscost: selectedGridData?.cumpartscost || "",
        assettransferdepartmentid: selectedGridData?.assettransferdepartmentid || "",
        lastscheduledworkorder:selectedGridData?.lastscheduledworkorder || "",
        lastunscheduledworkorder:selectedGridData?.lastunscheduledworkorder || "",
        cumpartscost:selectedGridData?.cumpartscost || "",
        supplier:selectedGridData?.supplier || "",
        //attachments        
        //others
        cumlabourcost: "",
      //  disposalby: "",
      //  disposalmethod: "",
        createdby: selectedGridData?.createdby || "",
        createddate: "",
        modifiedby: selectedGridData?.modifiedby || getmodifiedBy,
        timestamp:selectedGridData?.timestamp || "",
        modifieddate: "",
        isdeleted: false,
        processingpercentage: selectedGridData?.processingpercentage || "",
        isOldSupplier:selectedGridData?.isOldSupplier || selectedGridData?.isoldsupplier || ""
    };
};


//FEMS payload
const femsGrapPayloads = (selectedGridData) => {    
    return {
        //basicDetails fields
        FemtestingandcommissionId: selectedGridData?.femtestingandcommissionId || "",
        FemassetclassificationId: selectedGridData?.femassetclassificationId || "",
        FemassetcriticalityId: selectedGridData?.criticality || selectedGridData?.femassetcriticalityId || "",
        FemworkgroupdetailsId: selectedGridData?.workGroupId || selectedGridData?.femworkgroupdetailsId || "",
        FemassetppmstatusId: selectedGridData?.femassetppmstatusId || selectedGridData?.FemassetppmstatusId || "",
        //assetSpecification fields
        engineno: selectedGridData?.engineno || "",
        chassisno: selectedGridData?.chassisno || "",
        registerationno: selectedGridData?.registerationno || "",
        FemassetstatusId: selectedGridData?.femassetstatusId || selectedGridData?.FemassetstatusId || "",
        FemassetconditioncategoryId: selectedGridData?.femassetconditioncategoryId || selectedGridData?.FemassetconditioncategoryId || "",

        //purchaseDetails fields
        FemassetpurchasecostflagId: selectedGridData?.FemassetpurchasecostflagId || selectedGridData?.femassetpurchasecostflagId || "",
        FemassettransferId: selectedGridData?.femassettransferId || "",
        //attachments
        femassetattachments: [],
        //others
        femassetconditionstatuses: [],
        femassetchildinfos: [],
        femassethistorymaintenances: [],
        femppmscheduledetails: [],
        femdepartmentworkrequestheaders: [],
        femcontractregisterdetails: [],
        femassetservicechanges: [],
        femunscheduledworkorderheaders: [],
        FemassettypeId:1,
    };
};

//BEMS payload
const bemsGrapPayloads = (selectedGridData) => {

    return {
        //basicDetails fields
        BemtestingandcommissionId: selectedGridData?.bemtestingandcommissionId || "",
        BemassetclassificationId: selectedGridData?.bemassetclassificationId || "",
        BemassetcriticalityId: selectedGridData?.criticality || selectedGridData?.bemassetcriticalityId || "",
        BemworkgroupdetailsId: selectedGridData?.workGroupId || selectedGridData?.bemworkgroupdetailsId || "",
        BemassetppmstatusId: selectedGridData?.bemassetppmstatusId || selectedGridData?.BemassetppmstatusId || "",
        //assetSpecification fields
        BemassetstatusId: selectedGridData?.bemassetstatusId || selectedGridData?.BemassetstatusId || "",
        BemassetconditioncategoryId: selectedGridData?.bemassetconditioncategoryId || selectedGridData?.bemassetconditioncategoryId || "",
        BemmedicalequipmentcategoryId: selectedGridData?.bemmedicalequipmentcategoryId || selectedGridData?.BemmedicalequipmentcategoryId || "",
        //purchaseDetails fields
        BemassetpurchasecostflagId: selectedGridData?.bemassetpurchasecostflagId || selectedGridData?.BemassetpurchasecostflagId || "",
        BemassettransferId: selectedGridData?.bemassettransferId || "",
        //attachments
        bemassetattachments: [],
        //others
        bemassetconditionstatuses: [],
        bemassetchildinfos: [],
        bemassethistorymaintenances: [],
        bemppmscheduledetails: [],
        bemdepartmentworkrequestheaders: [],
        bemcontractregisterdetails: [],
        bemassetservicechanges: [],
        bemunscheduledworkorderheaders: [],
        BemassettypeId:2,
    }
}

//function responsible for creating asset in api
const createAsset = async (selectedGridData, data, type) => {
    const createdBy = getCreatedBy('createdBy');
    const payloadForSerive = type === "FEMS" ? femsGrapPayloads(selectedGridData) : bemsGrapPayloads(selectedGridData);
    const mergedRequestBody = { ...commonFillRequestBody(selectedGridData), ...payloadForSerive, ...data, createdby: createdBy };
    try {
        const token = getAuthToken('id_token');
        const url = type === "FEMS" ? `${FemsGraph}/api/femassetregisters` : `${BemsGraph}/api/bemassetregisters`;
        const response = await axios.post(url, mergedRequestBody, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });
        if (response.status >= 200 && response.status <= 204) {
            return response.data;
        } else {
            console.log(`Error ${response.status}: ${response.statusText}`);
        }
    } catch (err) {
        console.log(err.message);
    }
};

//function responsible for updating asset in api
const updateAsset = async (selectedGridData, data, type, isEditMode, changedkeys) => {
    const payloadForSerive = type === "FEMS" ? femsGrapPayloads(selectedGridData) : bemsGrapPayloads(selectedGridData);
    const mergedRequestBody = { ...commonFillRequestBody(selectedGridData), ...payloadForSerive, ...data };
    
    try {
        const token = getAuthToken('id_token');
        const url = type === "FEMS" ? `${FemsGraph}/api/femassetregisters/${mergedRequestBody.id}` : `${BemsGraph}/api/bemassetregisters/${mergedRequestBody.id}`;
        const response = await axios.put(url, mergedRequestBody, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });

        if(isEditMode && changedkeys){
            if (response.status >= 200 && response.status <= 204) {
                const url = type === "FEMS" ? `${FemsGraph}/api/femassetaudittrails` : `${BemsGraph}/api/bemassetaudittrails`;
                const femorbem = type === "FEMS" ? "femassetregisterId" : "bemassetregisterId";
                const getmodified=getModifiedBy('modifiedBy');
                const payload = { ...mergedRequestBody, id: "",createdby:selectedGridData?.createdby,[femorbem]: mergedRequestBody?.id, modifiedby:getmodified,Modifiedfieldname:changedkeys};            
                try {
                    const saveDataToAuditTrail = await axios.post(url, payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Accept': 'text/plain',
                            'Content-Type': 'application/json'
                        }
                    });
                    if(saveDataToAuditTrail){
                        return response.data;
                    }
                } catch (error) {
                    console.log(error);
                }
                // return response.data;
            } else if (response.status === 401) {
                console.log("Unauthorized");
            }
        }else{
            return response?.data;
        }
        
    } catch (err) {
        console.log(err);
    }
};

const assetCreateUpdateRepository = {
    createAsset,
    updateAsset
};

export default assetCreateUpdateRepository;
